import { CardReport } from 'core/tarjeta/models/CardReport';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { formatCurrency } from 'shared/utils';

export const CardAuthorizationsDetails = (props: {
  cardData: CardReport;
  goToAccountMovements(): void;
  goBack(): void;
}) => {
  return (
    <Card>
      <Card.Header className="text-center">
        {props.cardData.denominacionCuenta}
      </Card.Header>
      <Card.Body>
        <p className="fw-semibold text-center">
          Autorizaciones Tarjeta: {props.cardData.numeroTarjeta}
        </p>
        <Row>
          <Col>
            <p className="fw-semibold">
              Denominación cuenta tarjeta: {props.cardData.denominacionTarjeta}
            </p>
          </Col>
          <Col>
            <p className="fw-semibold ">
              Nro. cuenta tarjeta: {props.cardData.cuentaOrigen}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="fw-semibold ">
              Saldo inicial: {formatCurrency(props.cardData.saldo)}
            </p>
          </Col>
          <Col></Col>
        </Row>
        <p className="fw-semibold text-center">Período actual</p>
        <Row className="text-center">
          <Col>
            <Button
              variant="secondary"
              className="me-2"
              onClick={props.goToAccountMovements}
            >
              Ver movimientos de la cuenta
            </Button>
            <Button variant="secondary" onClick={props.goBack}>
              Volver
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
